import { Link } from "react-router-dom";
import styled from "styled-components";

import color from "../../constants/color";
import materialUI from "../../material-UI";

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 24px;
`;
export const Row = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  flex-direction: row;
`;
export const Span = styled.div`
  color: ${color.darkgrey};
  font-size: 13px;
  text-decoration: none;
  margin: 2px 8px 0px 8px;
`;
export const Img = styled.img`
  height: 20px;
`;
export const OnPress = styled(materialUI.IconButton)`
  width: 16px;
  height: 16px;
  margin-right: 20px;
`;
export const DropDown = styled(materialUI.Card)`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 15px;
`;
export const Nav = styled(materialUI.Breadcrumbs)``;
export const Route = styled(Link)`
  color: ${color.darkgrey};
  font-size: 13px;
  text-decoration: none;
`;
export const Card = styled(materialUI.Card)`
  position: fixed;
  top: 16px;
  left: calc(var(--sidebar-width, 90px) + 16px);
  width: calc(100% - var(--sidebar-width, 90px) - 32px);
  z-index: 999;
  height: 48px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1) !important;
  transition: left 0.3s ease, width 0.3s ease;
  border-radius: 12px !important;
`;
export const Space = styled.div`
  width: ${(props) => props.style?.width};
`;
export const IconHome = styled.a`
  margin: 2px 8px 0px 15px;
`;

export const LoadingSave = styled(materialUI.CircularProgress)``;
